<script>
  import { getContext } from 'svelte'
  import { cssPrefix } from '../helper-classes.js'

  // export let elementName
  // export let variant
  export let config = {}
  export let id = null

  const element = getContext('currentElement')

  const layout = config.layout || getContext('formGroupLayout')
  if (layout === 'TwoCols') {
    config.blockClasses = [`${cssPrefix}form-block`, 'is-horizontal']
  } else {
    config.blockClasses = [`${cssPrefix}form-block`]
  }

  const classes = [`${cssPrefix}controls`]
  if (config.stacked) {
    classes.push('is-stacked')
  } else {
    classes.push('is-grouped')
  }
</script>

<div class={config.blockClasses && config.blockClasses.join(' ')}>
  <div class={`${cssPrefix}form-label`}>
    <div class={`${cssPrefix}label`} class:is-required={$element.required && !$element.disabled}>
      <label for={id} id="{id}-label">{$element.label}</label>
    </div>
  </div>

  <div class={`${cssPrefix}form-field`} aria-labelledby="{id}-label">
    <div class={classes.join(' ')}>
      <slot />
    </div>
  </div>

  {#if $element.info}
    <div class={`${cssPrefix}form-info`} class:has-info={$element.info}>
      <div class={`${cssPrefix}message`}>
        <p id="${id}-description">{$element.info}</p>
      </div>
    </div>
  {/if}

  {#if $element.error}
    <div class={`${cssPrefix}form-error`}>
      <div class={`${cssPrefix}message is-status-error`}>
        <p id="${id}-error">{$element.error}</p>
      </div>
    </div>
  {/if}
</div>
